import * as tsx from 'vue-tsx-support';
import CgError from '../Error';
import Loader from '../Loader';
/**
 * Create a lazy loaded component.
 *
 * DO NOT USE IN A COMPUTED PROPERTY, the component might not load until the
 * second time the lazy loader is rendered.
 *
 * @param args The arguments used to construct the lazy loader.
 * @returns The given component wrapped as a lazy loader.
 */
export function lazyLoadView(args) {
    const loading = {
        inheritAttrs: false,
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        render(h) {
            if (args.customLoader != null) {
                return args.customLoader(h);
            }
            const props = {
                pageLoader: true,
                ...args.loaderOpts?.props,
            };
            return h(Loader, {
                props,
                class: args.loaderOpts?.class,
                style: args.loaderOpts?.style,
            });
        },
    };
    const error = args.errorComponent ?? {
        inheritAttrs: false,
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        render(h) {
            const props = {
                error: new Error(args.errorMessage),
                ...args.errorOpts?.props,
            };
            return h(CgError, {
                props,
                class: args.errorOpts?.class,
                style: args.errorOpts?.style,
            });
        },
    };
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    const AsyncHandler = () => ({
        component: args.getComponent(),
        loading,
        error,
        delay: 0,
        timeout: 15000,
    });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    const res = () => Promise.resolve(tsx.component({
        name: 'lazy-loader',
        inheritAttrs: false,
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        render(h) {
            return h(AsyncHandler, {
                attrs: this.$attrs,
                props: this.$props,
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
            });
        },
    }));
    return res;
}
